/**
 * `yyyy-MM-dd` format.
 *
 * This format should be used for all date inputs and outputs to and from the API and any component throughout the application.
 *
 * This specific format is consumable by the `date-fns` library; _not_ `Moment.js`.
 *
 * @example "2021-10-06"
 */
export const YYYY_MM_DD = 'yyyy-MM-dd';
/**
 * Date format to display the day of the week, day of the month, and month.
 * Depending on the locale, the format may vary.
 *
 * This function uses the `Intl.DateTimeFormat` API to format the date.
 *
 * Here are some examples:
 * - en-US: "Tuesday, October 6"
 * - en-GB: "Tuesday, 6 October"
 * - fr-CA: "mardi 6 octobre"
 * - fr-FR: "mardi 6 octobre"
 * - es-ES: "martes, 6 de octubre"
 *
 * @param date The date to format
 * @param locale The locale string to use
 * @returns The formatted date
 */
export function formatDateLong(date, locale) {
    return new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
    }).format(date);
}
/**
 * @example "Oct 6"
 * @param date
 * @param locale
 * @returns a string representing the date in the format "Oct 6"
 */
export function formatDateShort(date, locale) {
    return new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
    }).format(date);
}
export const defaultMomentDateFormat = 'MM/DD/YYYY';
//# sourceMappingURL=date-time-formatting.js.map